<script setup>
// Linha de detalhes da campanha de WhatsApp.
//
// Difere da do SMS porque a pergunta do operador é outra: não é só "de onde saiu e quando", é
// "qual template, para quem". A audiência é o que distingue duas campanhas com o mesmo template
// no mesmo dia — e era o que faltava para as cinco "Prova da Fase 2" deixarem de ser idênticas.
import Icon from 'dashboard/components-next/icon/Icon.vue';
import { messageStamp } from 'shared/helpers/timeHelper';
import { useI18n } from 'vue-i18n';

defineProps({
  inboxName: { type: String, default: '' },
  inboxIcon: { type: String, default: '' },
  audience: { type: String, default: '' },
  scheduledAt: { type: Number, default: 0 },
});

const { t } = useI18n();
</script>

<template>
  <div class="flex items-center gap-1.5 flex-shrink-0">
    <Icon :icon="inboxIcon" class="flex-shrink-0 text-n-slate-12 size-3" />
    <span class="text-sm font-medium text-n-slate-12">{{ inboxName }}</span>
  </div>

  <template v-if="audience">
    <span class="flex-shrink-0 rounded-full size-1 bg-n-slate-9" />
    <span class="flex-shrink-0 text-sm text-n-slate-11 whitespace-nowrap">
      {{ t('CAMPAIGN.WHATSAPP.CARD.CAMPAIGN_DETAILS.AUDIENCE') }}
    </span>
    <span class="text-sm font-medium truncate text-n-slate-12">
      {{ audience }}
    </span>
  </template>

  <span class="flex-shrink-0 rounded-full size-1 bg-n-slate-9" />
  <!-- `messageStamp` já recebe epoch em SEGUNDOS (`fromUnixTime`), que é o que o jbuilder manda.
       O `new Date(...)` que o card do SMS faz antes de chamar é redundante e só não quebra
       porque os dois erros se cancelam. Aqui vai direto. Formato dd/MM: a conta é brasileira. -->
  <span class="flex-shrink-0 text-sm font-medium text-n-slate-12">
    {{ messageStamp(scheduledAt, 'dd/MM HH:mm') }}
  </span>
</template>
